import React from 'react';
import block from 'propmods';
import { Channel } from '../../model/skill';
import { DraftStatusType } from '../../model/draft';
import { completedModerationStateTexts, draftStatusLabels } from '../../locale/ru/draftStatus';
import { CheckIcon } from '../../icons/check';
import { CrossIcon } from '../../icons/cross';
import * as keyset from 'i18n/DraftControlPanel';

import './ModerationPipelineItem.scss';
import i18n from '@yandex-int/i18n';

const b = block('ModerationPipelineItem');
const t = i18n(keyset);

export type ModerationPipelineItemState = 'completed' | 'current' | 'not-started' | 'rejected';

interface Props {
    channel: Channel;
    draftStatus: DraftStatusType<Channel>;
    state: ModerationPipelineItemState;
    position: number;
    slaTimingsText?: string;
    showSuccessText?: boolean;
}

interface IconProps {
    position: number;
    state: ModerationPipelineItemState;
}

const ModerationPipelineItemIcon: React.FC<IconProps> = ({ state, position }) => {
    switch (state) {
        case 'completed':
            return <CheckIcon size="m" color="#fff" type="stroke" />;
        case 'current':
            return <div {...b('number')}>{position}</div>;
        case 'not-started':
            return <div {...b('number')}>{position}</div>;
        case 'rejected':
            return <CrossIcon size="xs" color="#fff" />;
    }
};

export const ModerationPipelineItem: React.FC<Props> = ({
    channel,
    draftStatus,
    state,
    position,
    children,
    slaTimingsText,
    showSuccessText = true,
}) => {
    return (
        <div {...b({ state })}>
            <div {...b('icon')}>
                <ModerationPipelineItemIcon state={state} position={position} />
            </div>
            <div {...b('body')}>
                <div {...b('label')}>
                    {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        (draftStatusLabels as any)[channel][draftStatus]
                    }
                </div>
                {showSuccessText && state === 'completed' && (
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    <div {...b('status')}>{(completedModerationStateTexts as any)[channel][draftStatus]}</div>
                )}
                {state === 'rejected' && <div {...b('status')}>{t('skill-rejected')}</div>}
                {children}
                {slaTimingsText && <div {...b('timings')}>{slaTimingsText}</div>}
            </div>
        </div>
    );
};
